import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const HomeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M20.55 8.2L12.55 2.87C12.21 2.65 11.78 2.65 11.44 2.87L3.45 8.2C3.17 8.39 3 8.7 3 9.03V19.49C3 20.59 3.9 21.49 5 21.49H9V15.49C9 14.94 9.45 14.49 10 14.49H14C14.55 14.49 15 14.94 15 15.49V21.49H19C20.1 21.49 21 20.59 21 19.49V9.03C21 8.7 20.83 8.38 20.55 8.2Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 21.5H15"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

HomeIcon.displayName = 'HomeIcon';
